import { IFactorConfiguration, ICountryListItem } from '@aston/foundation/models';

import { ITenantInfos, IUser, IUserSession } from '../../authentication-module/models';
import { IStoreEntityStateSlice, createEntitySlice } from '../functions';
import { IConfigurationReferential } from '../../shared-module/models';
import { AppConfiguration } from '../../app.configuration';

export interface IAppState {
	isLoading: boolean;
	isFinished: boolean;
	bootstrapError: Error,
	validatorsLoaded: boolean;
	config: AppConfiguration;
	factorConfig: IStoreEntityStateSlice<IFactorConfiguration>;
	isScrolling: boolean;
	tenant: IStoreEntityStateSlice<ITenantInfos>;
	isPlatformCustomizationEnabled: boolean;
	logo: string;
	user: IUser;
	scripts: Record<string, boolean>;
	userSession: IUserSession;
	countries: IStoreEntityStateSlice<ICountryListItem[]>;
	language: IStoreEntityStateSlice<{language:string}>;
	referential: IStoreEntityStateSlice<IConfigurationReferential>;
}

export const initialState: IAppState = {
	isLoading: true,
	isFinished: false,
	bootstrapError: null,
	validatorsLoaded: false,
	config: null,
	factorConfig: createEntitySlice(),
	isScrolling: false,
	tenant: createEntitySlice(),
	isPlatformCustomizationEnabled: null,
	logo: null,
	user: null,
	scripts: {},
	userSession: {},
	countries: createEntitySlice({ entity: [] }),
	language: createEntitySlice(),
	referential: createEntitySlice(),
};
